export default "__VITE_ASSET__a01e62fd__"